import { render } from "./MenuItem.vue?vue&type=template&id=0b8c6fd8&scoped=true"
import script from "./MenuItem.vue?vue&type=script&lang=js"
export * from "./MenuItem.vue?vue&type=script&lang=js"

import "./MenuItem.vue?vue&type=style&index=0&id=0b8c6fd8&scoped=true&lang=css"

import exportComponent from "C:\\Develop\\web\\notigo_base\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b8c6fd8"]])

export default __exports__